/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Skip_OptionInputs */

const en_us2_history_transfer_skip_option = /** @type {(inputs: History_Transfer_Skip_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't import`)
};

const pt_br2_history_transfer_skip_option = /** @type {(inputs: History_Transfer_Skip_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não importar`)
};

const es_419_history_transfer_skip_option = /** @type {(inputs: History_Transfer_Skip_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No importar`)
};

const pt_pt2_history_transfer_skip_option = /** @type {(inputs: History_Transfer_Skip_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não importar`)
};

const fr_fr2_history_transfer_skip_option = /** @type {(inputs: History_Transfer_Skip_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne pas importer`)
};

const de_de2_history_transfer_skip_option = /** @type {(inputs: History_Transfer_Skip_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht importieren`)
};

const it_it2_history_transfer_skip_option = /** @type {(inputs: History_Transfer_Skip_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non importare`)
};

/**
* | output |
* | --- |
* | "Don't import" |
*
* @param {History_Transfer_Skip_OptionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_skip_option = /** @type {((inputs?: History_Transfer_Skip_OptionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Skip_OptionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_skip_option(inputs)
	if (locale === "es-419") return es_419_history_transfer_skip_option(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_skip_option(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_skip_option(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_skip_option(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_skip_option(inputs)
	return en_us2_history_transfer_skip_option(inputs)
});
export { history_transfer_skip_option as "history-transfer.skip_option" }